import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { DeliberyNoteServices } from "../services";
import { DeliberyNoteViewPage } from "../delibery-note-view/delibery-note-view/delibery-note-view";
import { ExpensesDenoCreateDataPage } from '../../income-expenses/expenses-deno-create/expenses-deno-create-data/expenses-deno-create-data';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { SelectBetweenDatetime } from '../../components/popups/select-between-datetime/select-between-datetime';
import { DeliberyNoteCreateTypePage } from '../delibery-note-create/delibery-note-create-type/delibery-note-create-type';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the StockDeliberyNoteListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-delibery-note-list',
    templateUrl: 'delibery-note-list.html',
})
export class DeliberyNoteListPage {

    date_first: any;
    date_last: any;
    //datatable
    sorts = [
        { prop: 'date', dir: 'asc' },
        { prop: 'number', dir: 'asc' },
        { prop: 'provider_static', dir: 'asc' },
        { prop: 'waiter', dir: 'asc' },
        { prop: 'uid_provider_order', dir: 'asc' },
        { prop: 'state', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };
    events: any;
    deliveryNoteSubscription: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public deliberyNoteServices: DeliberyNoteServices,
        public globals: Globals,
        public translate: TranslateService,
        public toastCtrl: ToastController,
        public modalCtrl: ModalController) {

        this.globals.GAtrackView('Stock', 'Stock - Delibery notes - List', this.globals.restaurant.email, 'View', 'List delibery notes', 'Stock', '');

    }

    /**********************************************************/
    /*                          INIT                          */
    /**********************************************************/

    async ionViewWillEnter() {
        let loader = this.loadingCtrl.create({
            content: this.translate.instant('general-cargando-datos')
        });

        await loader.present();

        try {
            // Solo inicializar fechas si no están definidas (primera carga)
            // Esto preserva las fechas seleccionadas por el usuario al volver del detalle
            if (!this.date_first || !this.date_last) {
                let latestDeliberyNote = await this.deliberyNoteServices.getLatestDeliveryNote();

                if (latestDeliberyNote && latestDeliberyNote.date) {
                    const today = moment();
                    let latestDate: Date;

                    if (latestDeliberyNote.date instanceof Date) {
                        latestDate = latestDeliberyNote.date;
                    } else if (typeof latestDeliberyNote.date === "string") {
                        latestDate = new Date(latestDeliberyNote.date);
                    } else if (latestDeliberyNote.date.toDate) {
                        latestDate = latestDeliberyNote.date.toDate();
                    } else {
                        latestDate = new Date();
                    }

                    const latestMoment = moment(latestDate);

                    if (latestMoment.isAfter(today)) {
                        this.date_first = today.startOf('month').format('YYYY-MM-DDTHH:mm:ss');
                        this.date_last = today.endOf('month').format('YYYY-MM-DDTHH:mm:ss');
                    } else {
                        this.date_first = latestMoment.startOf('month').format('YYYY-MM-DDTHH:mm:ss');
                        this.date_last = today.endOf('month').format('YYYY-MM-DDTHH:mm:ss');
                    }
                } else {
                    this.date_first = moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss');
                    this.date_last = moment().endOf('month').format('YYYY-MM-DDTHH:mm:ss');
                }
            }

            this.searchDeliberyNotes();

        } catch (error) {
            // Solo inicializar en caso de error si no hay fechas definidas
            if (!this.date_first || !this.date_last) {
                this.date_first = moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss');
                this.date_last = moment().endOf('month').format('YYYY-MM-DDTHH:mm:ss');
            }
        } finally {
            await loader.dismiss();
        }
    }

    /**********************************************************/
    /*                        FUNCIONES                       */
    /**********************************************************/

    ionViewWillLeave() {
        if (this.deliveryNoteSubscription) {
            this.deliveryNoteSubscription.unsubscribe();
        }
    }

    //funcion que abre el modal para seleccionar fechas
    openSelectDatetimeModal() {
        let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
            title: this.translate.instant('general-albaranes'),
            date_first: this.date_first,
            date_last: this.date_last,
            cash_bool: false,
        });
        profileModal.onDidDismiss(data => {
            if (data) {
                this.date_first = data.date_first;
                this.date_last = data.date_last;
                //
                this.searchDeliberyNotes();
            }
        });
        profileModal.present();
    }

    // Function to search delivery notes between selected dates
    async searchDeliberyNotes() {
        // Validar y convertir dates con moment
        const dateFirst = moment(this.date_first);
        const dateLast = moment(this.date_last);

        // Validar que son dates vàlides
        if (!dateFirst.isValid() || !dateLast.isValid()) {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-fechas-invalidas') || 'Dates invàlides. Si us plau, selecciona dates correctes.',
                duration: 3000,
                position: 'top'
            });
            toast.present();
            return;
        }

        // Validar rang - usar moment.isAfter() en lugar de comparación de strings
        if (dateFirst.isAfter(dateLast)) {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-selecciona-rango-fechas-correcto'),
                duration: 3000,
                position: 'top'
            });
            toast.present();
            return;
        }

        try {
            // Normalizar formato para el backend (YYYY-MM-DD HH:mm:ss)
            const dateFirstFormatted = dateFirst.format('YYYY-MM-DD HH:mm:ss');
            const dateLastFormatted = dateLast.format('YYYY-MM-DD HH:mm:ss');

            await this.deliberyNoteServices.getPagesDelibery(
                false,
                dateFirstFormatted,
                dateLastFormatted
            );
        } catch (error) {
            console.error('Error searching delivery notes:', error);
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-error-buscar-albaranes') || 'Error cercant albarans. Si us plau, torna-ho a intentar.',
                duration: 3000,
                position: 'top'
            });
            toast.present();
        }
    }

    /**********************************************************/
    /*                         NAVCTRL                        */
    /**********************************************************/

    openDeliberyNoteView(delibery_note) {
        this.navCtrl.push(DeliberyNoteViewPage, {
            delibery_note_uid: delibery_note.UID,
        });
    }

    openDeliberyNoteCreate() {
        this.navCtrl.push(DeliberyNoteCreateTypePage);
    }

    openCreateExpense() {
        this.navCtrl.push(ExpensesDenoCreateDataPage);
    }

    onSort(event) {
        var providers_array = this.deliberyNoteServices.deno_array_filtered;
        switch (event.column.name) {
            case 'date':
                providers_array.sort((a, b) => {
                    if (a.date_format && b.date_format) {
                        return event.newValue === 'asc' ? a.date_format.localeCompare(b.date_format) : b.date_format.localeCompare(a.date_format);
                    } else {
                        return 0;
                    }
                });
                break;
            case 'number':
                providers_array.sort((a, b) => {
                    if (a.number && b.number) {
                        return event.newValue === 'asc' ? a.number.localeCompare(b.number) : b.number.localeCompare(a.number);
                    } else {
                        return 0;
                    }
                });
                break;
            case 'provider_static':
                providers_array.sort((a, b) => {
                    if (a.provider_static && b.provider_static) {
                        return event.newValue === 'asc' ? a.provider_static.localeCompare(b.provider_static) : b.provider_static.localeCompare(a.provider_static);
                    } else {
                        return 0;
                    }
                });
                break;
            case 'waiter':
                providers_array.sort((a, b) => {
                    if (a.waiter && b.waiter) {
                        return event.newValue === 'asc' ? a.waiter.localeCompare(b.waiter) : b.waiter.localeCompare(a.waiter);
                    } else {
                        return 0;
                    }
                });
            case 'uid_provider_order':
                providers_array.sort((a, b) => {
                    if (a.uid_provider_order && b.uid_provider_order) {
                        return event.newValue === 'asc' ? a.uid_provider_order.localeCompare(b.uid_provider_order) : b.uid_provider_order.localeCompare(a.uid_provider_order);
                    } else {
                        return 0;
                    }
                });
            case 'state':
                providers_array.sort((a, b) => {
                    if (a.state && b.state) {
                        return event.newValue === 'asc' ? a.state.localeCompare(b.state) : b.state.localeCompare(a.state);
                    } else {
                        return 0;
                    }
                });
                break;
        }
        this.deliberyNoteServices.deno_array_filtered = providers_array;
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.openDeliberyNoteView(event.row);
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-list/delibery-note-list.ts